import useCommonStore from 'store/useCommonStore';

const useToast = () => {
	const { setToastData, toast_data } = useCommonStore();

	const setToast = (text: string, permanant?: boolean, is_error?: boolean) => {
		if (toast_data.mount) setToastData('mount', false);

		if (permanant === true) setToastData('permanant', true);
		if (is_error === true) setToastData('is_error', true);
		else {
			setToastData('permanent', false);
			setToastData('is_error', false);
		}
		setToastData('text', text);
		setToastData('mount', true);
	};

	return setToast;
};

export default useToast;
